var exports = {
  "b1": "UserProfileBadges.module__containerInline___dGRsRG",
  "v4": "UserProfileBadges.module__containerInlineMobile___dGRsRG",
  "D6": "UserProfileBadges.module__containerInlineDesktop___dGRsRG",
  "U3": "UserProfileBadges.module__containerOverlay___dGRsRG",
  "Qk": "UserProfileBadges.module__badgeMobile___dGRsRG",
  "EJ": "UserProfileBadges.module__badgeDesktop___dGRsRG",
  "J1": "UserProfileBadges.module__componentBadge___dGRsRG",
  "yH": "UserProfileBadges.module__componentBadgeIcon___dGRsRG",
  "vI": "UserProfileBadges.module__multilineTooltip___dGRsRG",
  "X8": "UserProfileBadges.module__sequenceBadge___dGRsRG",
  "Fi": "UserProfileBadges.module__sequenceBadgeMobile___dGRsRG",
  "Hd": "UserProfileBadges.module__sequenceBadgeDesktop___dGRsRG",
  "nf": "UserProfileBadges.module__link___dGRsRG",
};

module.exports = exports;
